export default {
    color: '#c6cbe1',
    urls: ['/about-moken', '/people-leadership', '/our-partners', '/portfolio', '/']
}
